import React from 'react';

export interface UseDataGridHorizontalScrollResult {
  scrollerRef: React.RefObject<HTMLDivElement>;
  isScrolledHorizontally: boolean;
}

export const useDataGridHorizontalScroll = (
  isEnabled: boolean
): UseDataGridHorizontalScrollResult => {
  const scrollerRef = React.useRef<HTMLDivElement>(null);
  const [isScrolledHorizontally, setIsScrolledHorizontally] =
    React.useState(false);

  React.useEffect(() => {
    const scroller = scrollerRef.current;
    if (!isEnabled || !scroller) {
      setIsScrolledHorizontally(false);
      return undefined;
    }

    const onScrollerScroll = () => {
      setIsScrolledHorizontally(scroller.scrollLeft > 0);
    };

    onScrollerScroll();
    scroller.addEventListener('scroll', onScrollerScroll, { passive: true });
    return () => scroller.removeEventListener('scroll', onScrollerScroll);
  }, [isEnabled]);

  return { scrollerRef, isScrolledHorizontally };
};
